import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SalesDashboardService {

  
  constructor(private apiService:ApiService) { }

  getTotalReadyProductAmount(queryParams: HttpParams){
    return this.apiService.get('invoice/total-amount-paid', queryParams)
  }
   getTotalAssemblyProductSale(queryParams: HttpParams) {
    return this.apiService.get('stocks/get-total-assembly-productSale', queryParams);
  }
  // getTotalProductProductSale(queryParams: HttpParams) {
  //   return this.apiService.get('stocks/get-total-assembly-productSale', queryParams);
  // }
  
  getTotalReadyProductSale(queryParams: HttpParams) {
  return this.apiService.get('stocks/get-total-ready-product-sale', queryParams);
}

 getTopTenCustomers(queryParams: HttpParams) {
  return this.apiService.get('invoice/top-ten-customers', queryParams);
}
  
 getTotalExpenses(queryParams: HttpParams) {
  return this.apiService.get('expenses/total', queryParams);
}
getNewCategories(queryParams: HttpParams) {
  return this.apiService.get('categories/new', queryParams);
}
getSalesExecutiveReport(queryParams: HttpParams) {
  return this.apiService.get('user_staff/sales-report', queryParams);
}

}